import React from 'react';
import 'objectFitPolyfill';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'objectFitPolyfill';
//TODO: remove after finishing IE support
import './utils/closestPolyfill';

import { CacheProvider } from '@emotion/react';
import loadable, { loadableReady } from '@loadable/component';
import { ThemeProvider } from '@mui/material/styles';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import JSCookies from 'js-cookie';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';

import App from './App';
import IncognitoWarning from './components/IncognitoWarning/IncognitoWarning';
import RmContext from './context/RmContext';
import createEmotionCache from './createEmotionCache';
import i18n from './i18n';
import * as serviceWorker from './serviceWorker';
import './styles.css';
import theme from './theme';
import { checkIsLocalStorageBlocked, getHasAuthCookie } from './utils/helpers';

const cache = createEmotionCache();

/**
 *  uncomment to enable msw intercepting
 */
if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_MSW) {
  const { worker } = require('./browser');
  worker.start();
}

loadable.lib(() => import('react-app-polyfill/ie9'));
loadable.lib(() => import('react-app-polyfill/stable'));

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [new Integrations.BrowserTracing()],
    environment: process.env.REACT_APP_BUILD_TYPE,
    tracesSampleRate: process.env.REACT_APP_BUILD_TYPE === 'stage' ? 1.0 : 0.25,
  });
}

const hasAuthenticatedCookie = getHasAuthCookie(JSCookies.get());

loadableReady(() => {
  checkIsLocalStorageBlocked()
    ? ReactDOM.render(
        <ThemeProvider theme={theme}>
          <I18nextProvider i18n={i18n}>
            <IncognitoWarning />
          </I18nextProvider>
        </ThemeProvider>,
        document.getElementById('root'),
      )
    : ReactDOM.hydrate(
        <RmContext.Provider value={{ tag: '' }}>
          <CacheProvider value={cache}>
            <App
              type="client"
              client={undefined}
              routerContext={undefined}
              location={undefined}
              hasAuthenticatedCookie={hasAuthenticatedCookie}
              host={window?.location?.hostname}
            />
          </CacheProvider>
        </RmContext.Provider>,
        document.getElementById('root'),
      );
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
if (!process.env.REACT_APP_MSW) {
  serviceWorker.unregister();
}
